export default __webpack_public_path__ + "static/media/planning.f0ce8b0f.jpg";